import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Card, Grid } from '@mui/material';
import { TwoFaForm } from '../sections/auth/twofa';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));


const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function TwoFaPage() {
  return (
    <>
      <Helmet>
        <title> TwoFa | Genesis Platform  </title>
      </Helmet>
      <div className="login-screen f2a">
        <Container maxWidth={false} className="login-right-padding max-widh-twofa">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
              <StyledRoot>
                <StyledContent>
                  <Card sx={{ p: 0 }}>
                    <TwoFaForm />
                  </Card>
                </StyledContent>
              </StyledRoot>
            </Grid>
            <Grid item xs={12} md={8} lg={8}>
              <div className="bg-login-new">
                <div className="fit-login-area">
                  <h2>We are glad to see you again!</h2>
                  <h1>Empowering You to Manage Third-Party Risks with Confidence</h1>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
